export const firebaseConfig = {
  apiKey: "AIzaSyAavxpQuAg-ug-qq1Z0WugKFoCmdLvJBKU",
  authDomain: "longmod.firebaseapp.com",
  projectId: "longmod",
  storageBucket: "longmod.appspot.com",
  messagingSenderId: "873565360580",
  measurementId: "G-F98X7W5GNE",
  appId: "1:873565360580:web:af3f9f253403feb6989491",
};
